<template>
  <div class="c-main-container">

    <BackLink :to="backTo"/>

    <h1><i class="fal fa-info-circle"></i> お知らせ</h1>

    <div v-if="show">
      <div class="detail">
        <div v-for="(detail, i) in data" :key="i">
          <div v-if="detail.id === newsId" class="detail">
            <div class="title">{{detail.title}}</div>
            <div class="date">{{detail['date_text']}}</div>
            <div class="body">
              <span v-html="detail.body"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      読み込み中...
    </div>

    <AdSense/>

    <div class="news-container">
      <div class="contents">
        <div v-for="(detail, i) in data" :key="i" class="inline-container">
          <router-link :to="{name: 'News', params:{id: detail.id}}">
            {{detail['date_text']}} {{detail.title}}
          </router-link>
        </div>
      </div>
    </div>

    <div v-if="isNoData">
      お知らせはありません
    </div>

  </div>
</template>

<script>

/**
 * UserNews preload でデータを取得しにいく
 * 他は表示のみ
 */

import BackLink from '@/components/project/BackLink';
import AdSense from '@/components/project/AdSense';

export default {
  components: {
    BackLink,
    AdSense
  },
  data () {
    return {
      store: 'news',
      lock: false,
      show: false
    };
  },
  created: function () {
    this.standby = false;

    this.initialize();
  },
  watch: {
    '$route' () {
      this.standby = false;
    },
    lock: function () {
      // ローディング表示
      if (this.lock === true) {
        this.$store.dispatch('loading/open').then();
      } else {
        this.$store.dispatch('loading/close').then();
      }
    }
  },
  computed: {
    backTo: function () {

      let userId = this.$store.getters['auth/userId'];
      console.log(userId);

      if (userId >= 1) {
        return {name: 'Home'};
      } else {
        return {name: 'Welcome'};
      }

    },
    newsId: function (){
      return parseInt(this.$route.params.id);
    }
},
  methods: {
    loaded: function () {
      console.log('loaded');

      this.standby = true;
    },
    initialize: function () {

      if (this.lock === true) {
        // console.log('lock', this.lock);
        return;
      }

      let params = {};
      // console.log(params);

      // ロック
      this.lock = true;

      let dispatch = this.store + '/latest';

      this.$store.dispatch(dispatch, params).then(() => {

        // ロック解除
        this.lock = false;

        let status = this.$store.getters[this.store + '/status'];

        if (status === 200) {

          this.data = this.$store.getters[this.store + '/latest'];

          this.show = true;

        } else {

          this.show = true;

        }

      }).catch((err) => {
        console.warn(err);

        // ロック解除
        this.lock = false;

        this.show = true;

      });
    }
  }
};

</script>

<style lang="scss" scoped>

  hr {
    margin-top: 10px;
  }

  .detail {

    .title {
      font-size: 16px;
      border-bottom: 1px solid #ddd;
    }

    .date {
      padding-top: 10px;
      font-size: 13px;
    }

    .body {
      padding: 10px 0 0 20px;
      white-space: pre-wrap;
    }
  }

  .inline-container {
    line-height: 30px;
  }

  a {
    border-bottom: 1px solid #eee;
    padding: 0 4px;
  }

  // 801以上
  @media screen and (min-width: 801px) {

    .detail {
      width: 700px;
      margin-top: 20px;
      margin-bottom: 20px;
      text-align: left;
    }

    .news-container {
      width: 700px;
      margin-top: 20px;
      text-align: left;

      .contents {
        font-size: 14px;
      }
    }
  }

  // 800まで
  @media screen and (max-width: 800px) {

    .detail {
      margin-top: 20px;
      margin-bottom: 20px;
      text-align: left;
    }

    .news-container {

      margin-top: 20px;
      text-align: left;

      .contents {
        font-size: 14px;
      }
    }
  }

</style>
